import Chip from "@mui/material/Chip"
import Stack from "@mui/material/Stack"
import { styled } from "@mui/material/styles"
import { Link as RouterLink, useMatch } from "react-router"
import { Teams } from "./teamStatic"

export default styled(props => {
  const currentTeam = useMatch("/resources/team/:team")?.params?.team

  return (
    <Stack direction="row" {...props}>
      {Teams.map((team, index) => (
        <Chip
          title={`LIMIT ${new Date().getFullYear()} ${team.name} team`}
          aria-label={`LIMIT ${new Date().getFullYear()} ${team.name} team`}
          component={RouterLink}
          to={team.abbr}
          key={index}
          clickable
          label={team.name}
          variant={team.abbr === currentTeam ? "filled" : "outlined"}
        />
      ))}
    </Stack>
  )
})(({ theme }) => ({
  flexWrap: "wrap",
  "& a": {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1)
  }
}))
